import { NextActionTaskType, InteractionType } from 'types/flows';
import React from 'react';
import { DoNotDisturbOn, CheckCircle } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import { ITheme } from 'types/theme';

// eslint-disable-next-line react/require-default-props
type Props = { actionType?: string };

const ActionTypeIcon = ({ actionType }: Props) => {
	const theme = useTheme<ITheme>();
	const { icons } = theme.assets.socials;

	switch (actionType) {
		case NextActionTaskType.success:
			return <CheckCircle color="success" sx={{ width: 16 }} />;
		case NextActionTaskType.error:
			return <DoNotDisturbOn color="error" sx={{ width: 16 }} />;
		case InteractionType.facebook:
			return <img src={icons.FacebookIcon()} alt={actionType} width="18" />;
		case InteractionType.google:
			return <img src={icons.GoogleIcon()} alt={actionType} width="18" />;
		case InteractionType.github:
			return <img src={icons.GithubIcon()} alt={actionType} width="18" />;
		case InteractionType.microsoft:
			return <img src={icons.MicrosoftIcon()} alt={actionType} width="18" />;
		case InteractionType.apple:
			return <img src={icons.AppleIcon()} alt={actionType} width="18" />;
		case InteractionType.biomertrics:
			return <img src={icons.FingerprintIcon()} alt={actionType} width="18" />;
		case InteractionType.passkey:
			return <img src={icons.PasskeyIcon()} alt={actionType} width="18" />;
		case InteractionType.sso:
			return <img src={icons.SSOIcon()} alt={actionType} width="18" />;
		case InteractionType.discord:
			return <img src={icons.DiscordIcon()} alt={actionType} width="18" />;
		case InteractionType.gitlab:
			return <img src={icons.GitlabIcon()} alt={actionType} width="18" />;
		case InteractionType.linkedin:
			return <img src={icons.LinkedinIcon()} alt={actionType} width="18" />;
		default:
			return null;
	}
};

export default ActionTypeIcon;
